import { PROJECT_ENTITY_CATEGORIES } from "../ProjectViewPage/constants/project-entity-category.ts"

interface ProjectTypeCategoryUpdate {
  project_type_id: string
  category: number
}

/**
 * The create endpoint assigns every type as Standard, so a non-default
 * category has to be applied afterwards against the assignment it just made.
 */
function projectTypeCategoryUpdates(
  projectTypes: string[] | null | undefined,
  categories: Record<string, number> | null | undefined
): ProjectTypeCategoryUpdate[] {
  return Object.entries(categories || {})
    .filter(
      ([project_type_id, category]) =>
        projectTypes?.includes(project_type_id) &&
        category !== PROJECT_ENTITY_CATEGORIES.STANDARD
    )
    .map(([project_type_id, category]) => ({ project_type_id, category }))
}

export { projectTypeCategoryUpdates, type ProjectTypeCategoryUpdate }
